var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"the-header flex flex-m flex-between"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/the-header-logo.png")}})]),_c('div',{staticClass:"msg"},[_vm._v("生态文明现代化建设服务商")])])
}]

export { render, staticRenderFns }